import React, { useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GridLayout from "./Component/GridLayout";
import _ from "lodash";
import { AxiosAPI, getGroupID } from '../../../helpers/AxiosAPI';
import { Colxx } from '../../../components/common/CustomBootstrap';
import {
    gAPI_WidgetBy_PropertyId,
    gAPI_GetEvent_By_Place_Predict,
    gAPI_GetEvent_By_Miles_Predict,
    gAPI_GetEvent_By_Country_Predict,
} from '../../../constants/APIs';

function Insights({ propertyId }) {
    const [widgetData, setwidgetData] = useState([]);
    const [layout, setLayout] = useState({
        lg: []
    });
    useEffect(() => {
        LoadData();
    }, [propertyId]);

    const LoadData = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_WidgetBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}`,
        }).then(
            (res) => {
                let getPostion = [];
                if (res.data.length > 0) {
                    let post = res.data.map((item, index) => {
                        return JSON.parse(item.position)
                    });
                    getPostion = post.map((i, l) => {
                        return i[0]
                    })
                }
                var listAdd = [];
                // let lastPoints = getPostion[getPostion.length - 1];
                // listAdd = getPostion.concat({
                //     w: 4,
                //     h: 6,
                //     x: (lastPoints.x * 2),
                //     y: lastPoints.y,
                //     i: (getPostion.length === 0 ? 0 : ((getPostion.length - 1) + 1)).toString(),
                //     static: false
                // })
                setLayout({ lg: getPostion });
                setwidgetData(res.data);
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onLayoutChange = (layout) => {
        setLayout(layout);
    }

    const stringifyLayout = () => {
        // return layout.lg.map(function (l) {
        //     return (
        //         <div className="layoutItem" key={l.i}>
        //             <b>{l.i}</b>: [{l.x}, {l.y}, {l.w}, {l.h}]
        //         </div>
        //     );
        // });
    }
    return (
        <Fragment>
            <div className="dashboard-wrapper">
                <Row>
                    <Colxx lg="12">
                        <Card>
                            <CardBody>

                                <div className="layoutJSON d-none">
                                    Displayed as <code>[x, y, w, h]</code>:
                                    <div className="columns">{stringifyLayout()}</div>
                                </div>
                                <GridLayout
                                    widgetData={widgetData}
                                    layoutData={layout}
                                    propertyId={propertyId}
                                    groupId={getGroupID()}
                                    LayoutChange={onLayoutChange}
                                    LoadData={LoadData}
                                ></GridLayout>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
            </div>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId
    };
};

export default injectIntl(connect(mapStateToProps, {})(Insights));